/** Note times and durations use beats; returned events use absolute audio seconds. */
export function scheduleWindow(pattern, { from, to, origin = 0, loop = true }) {
  if (![from, to, origin, pattern.bpm, pattern.beats].every(Number.isFinite)
    || pattern.bpm <= 0 || pattern.beats <= 0 || to < from) {
    throw new RangeError('Invalid scheduling window or pattern clock');
  }
  const beat = 60 / pattern.bpm;
  const length = pattern.beats * beat;
  const first = loop ? Math.max(0, Math.floor((from - origin) / length)) : 0;
  const last = loop ? Math.max(-1, Math.ceil((to - origin) / length) - 1) : 0;
  const events = [];
  for (let cycle = first; cycle <= last; cycle += 1) {
    for (const note of pattern.notes) {
      const time = origin + cycle * length + note.time * beat;
      // Half-open windows prevent duplicates between successive scheduler ticks.
      if (time >= from && time < to) {
        events.push({ ...note, time, duration: note.duration * beat });
      }
    }
  }
  return events.sort((a, b) => a.time - b.time);
}

export function nextBoundary(time, origin, bpm, beatsPerBar = 4) {
  const bar = 60 / bpm * beatsPerBar;
  return origin + Math.max(0, Math.ceil((time - origin) / bar)) * bar;
}
